module.exports = __webpack_public_path__ + "assets/img/general.d64db41e.png";